import styled from '@emotion/styled';

export const ReportWidgetFullHeightContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
